/** Translation namespaces. Kept small — add one per module/feature as real screens land. */
export const NS = {
  COMMON: "common",
  ERRORS: "errors",
  ACCOUNT: "account",
  ACQUIRE: "acquire",
  ACCOUNT_SETUP: "account-setup",
  TEAM: "team",
} as const;

/** All loaded namespaces. */
export const NAMESPACES = [
  NS.COMMON,
  NS.ERRORS,
  NS.ACCOUNT,
  NS.ACQUIRE,
  NS.ACCOUNT_SETUP,
  NS.TEAM,
] as const;

/**
 * Supported languages. **fr is primary + fallback, en is the secondary.**
 *
 * The interface is LTR-only and ships French and English. There is no Arabic locale, font or
 * `dir` handling; bringing it back means restoring those, not flipping a flag.
 */
export const SUPPORTED_LNGS = ["fr", "en"] as const;

/** Fallback language: French, the platform default. */
export const FALLBACK_LNG = "fr";

export type AppLanguage = (typeof SUPPORTED_LNGS)[number];
